import { PropertiesType } from '../../types';
import { LoadedWorkflowV2 } from '../migrateTo2';

export type TaskPropertiesV3 = {
  id: string;
  nickname: string;
  userTimeEstimate: number | null;
  taskType: string;
  instrumentId: string | null;
  taskParameters: Record<string, string | number | boolean | string[]> | null;
  propertiesType: PropertiesType.Action;
};

export type CodeTaskProperties = Omit<
  TaskPropertiesV3,
  'userTimeEstimate' | 'instrumentId' | 'taskParameters' | 'propertiesType'
> & {
  scriptName: string;
  propertiesType: PropertiesType.Code;
};

type MinimalEdge = {
  id: string;
  type?: string;
  source: string;
  target: string;
  sourceHandle?: string | null;
  targetHandle?: string | null;
};

type VisualWorkflowV3 = Omit<
  LoadedWorkflowV2['visualWorkflow'],
  'taskProperties'
> & {
  taskProperties: Record<string, TaskPropertiesV3 | CodeTaskProperties>;
};

export type LoadedWorkflowV3 = Omit<LoadedWorkflowV2, 'visualWorkflow'> & {
  graph: {
    dataDependencyEdges: Array<MinimalEdge>;
  };
  visualWorkflow: VisualWorkflowV3;
};

export const _migrateTo3 = (
  loadedWorkflow: LoadedWorkflowV2
): LoadedWorkflowV3 => {
  const migratedTasks = Object.values(
    loadedWorkflow.visualWorkflow.taskProperties
  ).reduce<LoadedWorkflowV3['visualWorkflow']['taskProperties']>(
    (prev, current) => {
      return {
        ...prev,
        [current.id]: {
          ...current,
          propertiesType: PropertiesType.Action,
        },
      };
    },
    {}
  );
  return {
    workcellInstruments: loadedWorkflow.workcellInstruments,
    graph: {
      ...loadedWorkflow.graph,
      dataDependencyEdges: [],
    },
    visualWorkflow: {
      ...loadedWorkflow.visualWorkflow,
      taskProperties: migratedTasks,
    },
  };
};
